import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/users/notifications/sms")({
    beforeLoad: () => {
        throw redirect({ to: "/developer/sms-deliverability", replace: true });
    },
});
